import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { collectionScrollAuto } from '../../../services/script';

class BrandList extends Component{
    render(){
        const {mainBanner, themeLayoutId} = this.props
        return(
            <React.Fragment>

                {/* Kids & Pet Theme Start */}

                {(themeLayoutId === 'L04' || themeLayoutId === 'L05') &&
                <section className="section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            <Slider {...collectionScrollAuto} className="slide-6 no-arrow">
                                {!!mainBanner && mainBanner.map((infocus) => {
                                        return (
                                            <div key={infocus.Image.APP_PAGE_ID}>
                                                <div className="logo-block">
                                                    <Link to="/">
                                                        <img src="https://react.pixelstrap.com/multikart/assets/images/logos/1.png" alt="" />
                                                    </Link>
                                                </div>
                                            </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
                }

                {/* End Kids & Pet Theme */}
            </React.Fragment>
        )
    }
}
export default BrandList